import type { Tone } from '../../domain/types';

export function checkboxToneColor(tone: Tone): string {
  if (tone === 'ok') return 'var(--z-ok)';
  if (tone === 'warn') return 'var(--z-warn)';
  if (tone === 'bad') return 'var(--z-bad)';
  if (tone === 'flat') return 'var(--z-text-2)';
  return 'var(--z-accent)';
}
